import React, { useState, useRef } from 'react';
import { motion, AnimatePresence, useInView } from 'framer-motion';
interface FAQ {
  question: string;
  answer: string;
}
const FAQS: FAQ[] = [{
  question: '¿Para quién es este protocolo?',
  answer: 'Este protocolo fue creado específicamente para mujeres de 50 años en adelante que están atravesando la perimenopausia o menopausia y sienten que su cuerpo cambió: dificultad para bajar de peso, insomnio, bochornos, inflamación o falta de energía. No necesitas experiencia previa ni conocimientos de nutrición. Está diseñado para que puedas seguirlo desde tu celular, paso a paso, desde el primer día.'
}, {
  question: '¿Cómo recibo mi compra?',
  answer: 'Inmediatamente después de confirmar tu compra recibirás un correo electrónico con el enlace de descarga de todos tus materiales: el protocolo principal y los bonos que hayas seleccionado. El acceso es inmediato, disponible las 24 horas, desde cualquier dispositivo: celular, tablet o computadora.'
}, {
  question: '¿Necesito comprar productos especiales o suplementos?',
  answer: 'No. El protocolo está diseñado con ingredientes y alimentos que encuentras en cualquier supermercado de México. No requiere suplementos, pastillas ni productos especiales de ningún tipo. Todo lo que necesitas ya está disponible cerca de ti y a precios accesibles.'
}, {
  question: '¿Qué pasa si no me funciona?',
  answer: 'Tienes 7 días de garantía total. Si sientes que el protocolo no era para ti por cualquier razón, escríbenos y te devolvemos tu dinero completo. Sin preguntas, sin complicaciones. Queremos que entres con confianza y sin ningún riesgo.'
}, {
  question: '¿Para qué sirven los order bumps?',
  answer: 'Son dos guías complementarias que puedes agregar a tu protocolo por solo $5 USD cada una. El Kit de Emergencia para Bochornos te da herramientas de respuesta inmediata para los momentos difíciles del día. La Master-List del Supermercado te ahorra tiempo y dinero organizando exactamente qué comprar cada semana. Ninguno es obligatorio pero ambos hacen el proceso mucho más fácil.'
}];
export function FAQSection() {
  return <section className="py-12 md:py-16 bg-[#fdfbf6]" data-id="element-35">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-36">
        <div className="text-center mb-12" data-id="element-37">
          <h2 className="font-serif text-3xl md:text-4xl text-[#2d2d2d] mb-4" data-id="element-38">
            🌿 Preguntas Frecuentes
          </h2>
          <p className="text-lg text-[#7a8a6b]" data-id="element-39">
            Todo lo que necesitas saber antes de comenzar
          </p>
        </div>

        <div className="space-y-4" data-id="element-40">
          {FAQS.map((faq, idx) => <FAQItem key={idx} faq={faq} index={idx} data-id="element-41" />)}
        </div>
      </div>
    </section>;
}
function FAQItem({
  faq,
  index
}: {
  faq: FAQ;
  index: number;
}) {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-50px'
  });
  return <motion.div ref={ref} initial={{
    opacity: 0,
    y: 20
  }} animate={isInView ? {
    opacity: 1,
    y: 0
  } : {}} transition={{
    duration: 0.5,
    delay: index * 0.1
  }} className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden" data-id="element-42">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full px-6 py-5 flex items-center justify-between text-left focus:outline-none" data-id="element-43">
        <span className="font-medium text-[#2d2d2d] pr-8" data-id="element-44">{faq.question}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} className={`flex-shrink-0 ${isOpen ? 'text-[#2d4a3e]' : 'text-[#c9a961]'}`} data-id="element-45">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-46">
            <path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-47" />
          </svg>
        </motion.div>
      </button>

      <AnimatePresence data-id="element-48">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} className="overflow-hidden" data-id="element-49">
            <div className="px-6 pb-5 text-[#5d6e4f] leading-relaxed" data-id="element-50">
              {faq.answer}
            </div>
          </motion.div>}
      </AnimatePresence>
    </motion.div>;
}